import React from 'react';
import ReactDOM from 'react-dom';
import AppWrapper from './App';

ReactDOM.render(
  <AppWrapper />,
  document.getElementById('root')
);
